module.exports = __webpack_public_path__ + "img/logo.9d95e290.png";